/** ArtCard — the blueprint's signature card-art (radial gradient + sacred motif SVG).
 *  Ported deterministically from blueprint/nvl-shared.js (motifSVG + ART arrays).
 */

const MOTIFS = [
  '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="0.7"><circle cx="50" cy="50" r="44"/><circle cx="50" cy="50" r="34"/><path d="M50 14 L82 68 L18 68 Z"/><path d="M50 86 L18 32 L82 32 Z"/><circle cx="50" cy="50" r="3" fill="currentColor"/></svg>',
  '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="0.7"><circle cx="50" cy="50" r="14"/><circle cx="50" cy="36" r="14"/><circle cx="50" cy="64" r="14"/><circle cx="62" cy="43" r="14"/><circle cx="38" cy="43" r="14"/><circle cx="62" cy="57" r="14"/><circle cx="38" cy="57" r="14"/><circle cx="50" cy="50" r="42"/></svg>',
  '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="0.7"><g><path d="M50 50 Q56 28 50 8 Q44 28 50 50"/><path d="M50 50 Q72 44 92 50 Q72 56 50 50"/><path d="M50 50 Q56 72 50 92 Q44 72 50 50"/><path d="M50 50 Q28 56 8 50 Q28 44 50 50"/><path d="M50 50 Q68 32 78 22 Q60 36 50 50"/><path d="M50 50 Q68 68 78 78 Q60 64 50 50"/><path d="M50 50 Q32 68 22 78 Q40 64 50 50"/><path d="M50 50 Q32 32 22 22 Q40 36 50 50"/></g><circle cx="50" cy="50" r="40"/><circle cx="50" cy="50" r="4" fill="currentColor"/></svg>',
  '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="0.7"><circle cx="50" cy="50" r="44"/><circle cx="50" cy="50" r="32"/><circle cx="50" cy="50" r="20"/><circle cx="50" cy="50" r="8"/><path d="M50 6V94M6 50H94M18 18L82 82M82 18L18 82"/></svg>',
];

const ART = [
  "radial-gradient(80% 90% at 30% 10%, #4E1C50 0%, #1a0d1c 55%, #0b0710 100%)",
  "radial-gradient(80% 90% at 70% 15%, #2a3340 0%, #16181f 55%, #0a0b0f 100%)",
  "radial-gradient(80% 90% at 40% 0%, #5a3a2a 0%, #241712 55%, #0e0a09 100%)",
  "radial-gradient(80% 90% at 60% 10%, #2f3a30 0%, #161b16 55%, #0a0d0a 100%)",
  "radial-gradient(80% 90% at 50% 5%, #3a2150 0%, #1a1226 55%, #0a0712 100%)",
];

export function ArtCard({ seed = 0, motifSeed, className = "", children }) {
  const m = motifSeed ?? seed;
  return (
    <div className={`absolute inset-0 ${className}`} aria-hidden="true">
      <div className="absolute inset-0" style={{ background: ART[seed % ART.length] }} />
      <div
        className="absolute inset-0 grid place-items-center text-[rgba(221,219,221,0.55)]"
        dangerouslySetInnerHTML={{ __html: MOTIFS[m % MOTIFS.length] }}
        style={{ padding: "18%" }}
      />
      {children}
    </div>
  );
}
